import { GENIEBOARD_USER_ID, PUBLIC_USERNAME } from "../constants";

export const getActiveUserName = (username) => {
  if (username !== PUBLIC_USERNAME) {
    return username;
  }
  const userId = localStorage.getItem(GENIEBOARD_USER_ID);
  if (userId) {
    return userId;
  }
};
